<template lang="html">
  <div class="dialog" v-if="show">
    <div class="container">
      <div class="left">
        <!-- <div class="prev" @click="upward()"></div> -->
      </div>
      <div class="content">
        <div class="close" @click="close()">
          <img src="@assets/img/share/close.png" alt="close">
        </div>
        <!-- 图片 -->
        <div v-click-outside="closeBox" :class="{img: true, biggerImg: originImg.on}" v-show="now.type-0 === 1">
            <img ref="img" :src="now.url" @load="checkImgScale()" />
        </div>
        <!-- 视频 -->
        <div class="video" v-show="now.type-0 === 2">
          <video ref="video" :src="now.url" controls controlsList="nodownload" contextmenu="none"></video>
          <!-- 视频速度操作 -->
          <div class="btn">
            <button v-show="now.type-0 === 2" v-for="(s, i) in videoSpeeds.options" :class="{'on': s.multiple === videoSpeeds.now}" @click="changeSpeed(s.multiple)">{{s.title}}</button>
          </div>
        </div>
        <!-- 音频 controlsList="nodownload" -->
        <div class="video" v-show="now.type-0 === 3">
          <audio ref="audio" :src="now.url" controls controlsList="nodownload"></audio>
          <!-- <div class="_xnsaudio">
            <audio ref="audio" :src="now.url" @timeupdate="timeupdate" @loadedmetadata="loadedAudio" @ended="audioStop"></audio>
            <div class="_xnsleft pausing">
              <img class="_xnsplay" @click="playAudio()" src="@assets/img/common/playaudio.svg" alt="play">
              <img class="_xnspause" @click="pauseAudio()" src="@assets/img/common/pauseaudio.svg" alt="pause">
            </div>
            <div class="_xnsright">
              <p class="_xnstitle">
                1234567890
              </p>
              <p class="_xnsinfo">
                <span class="_xnsauthor">朱七月</span>
                <span class="_xnstimer">
                  <span class="_xnstime">0:0</span>
                    /
                  <span class="_xnsduration">0:0</span>
                </span>
              </p>
              <div class="_xnsprogress">
                <p class="_xnspercent" style="">
                  <span class="_xnsbar"></span>
                </p>
              </div>
            </div>
          </div> -->
        </div>

        <!-- <div class="pages">
          <p class="page">
            {{`${now.index}/${list.length}`}}
          </p>
        </div> -->
      </div>
      <div class="right">
        <div class="half">
          <!-- 关闭 -->
          <!-- <div class="close" @click="close()">
            <img src="@assets/img/common/close_viewer.svg" alt="close">
          </div> -->
          <!-- 放大图片 -->
          <div class="bigger">
            <img v-if="originImg.show" @click="toggleBiggerImg()" :src="originImg.on?originImg.icons.smaller:originImg.icons.bigger" alt="bigger">
          </div>
        </div>
        <!-- <div class="next" @click="downward()"></div> -->
        <div class="half"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {apis} from '@common/config'
import common from '@common/common'
import vClickOutside from "v-click-outside";

export default {
  directives: {
      clickOutside: vClickOutside.directive
  },
  name: 'mediaViwer',
  data() {
    return {
      list: [],
      now: {},
      videoSpeeds: {
        now: 1,
        options: [
          {multiple: 1, title: '1倍速'},
          {multiple: 2, title: '2倍速'},
          {multiple: 4, title: '4倍速'}
        ]
      },
      show: false,
      canDownload: false,
      originImg: {
        show: false,
        on: false,
        icons: {
          bigger: require('@assets/img/common/bigger_viewer.svg'),
          smaller: require('@assets/img/common/smaller_viewer.svg')
        }
      }
    }
  },
  methods: {
    closeBox() {
      this.close()
    },
    // playAudio() {
    //   this.$refs.audio.play()
    //   document.querySelector('._xnsleft').setAttribute('class', '_xnsleft playing')
    // },
    // pauseAudio() {
    //   this.$refs.audio.pause()
    //
    //   document.querySelector('._xnsleft').setAttribute('class', '_xnsleft pausing')
    // },
    // audioStop(e) {
    //   document.querySelector('._xnsleft').setAttribute('class', '_xnsleft pausing')
    // },
    // formatTime(time) {
    //   // 将时间转换为分秒的格式
    //   var durantion = parseInt(time - 0)
    //   var min = parseInt(durantion/60)
    //   var scd = durantion%60
    //
    //   return min + ':' + scd
    // },
    // loadedAudio(e) {
    //   const _xnsduration = document.querySelector('._xnsduration')
    //   _xnsduration.innerText = this.formatTime(e.target.duration)
    // },
    // timeupdate(e) {
    //   const duration = e.target.duration
    //   const currentTime = e.target.currentTime
    //   const percent = parseInt(currentTime/duration*100)
    //   console.log(currentTime/duration*100)
    //   const bar = document.querySelector('._xnspercent')
    //   const _xnstime = document.querySelector('._xnstime')
    //   _xnstime.innerText = this.formatTime(currentTime)
    //   bar.style.width = percent + '%'
    // },
    changeSpeed(multiple) {
      // 修改视频播放倍数
      const video = this.$refs.video
      this.$set(this.videoSpeeds, 'now', multiple)
      video.playbackRate = multiple
    },
    close() {
      this.show = false

      document.body.style.overflow = 'auto'
    },
    open(list, now, canDownload) {
      // list.forEach((i, d) => {
      //   i.index = d + 1
      //   if (now && now.url === i.url) {
      //     now.index = d + 1
      //     // this.$set(this.now, 'index', d + 1)
      //   }
      // })
      console.log(now)
      this.now = now || list[0]
      this.list = list

      this.canDownload = canDownload
      this.show = true
      this.$nextTick(() => {
        this.disableContextMenu()
      })
    },
    convertWord() {
      // 音视频转文字
      const info = {
        idstring: this.videoIdString
      }

      common.myFetch(apis.File_convert, info)
      .then((r) => {
        if (r) {
          this.$toast(r)
        }
      })
    },
    checkImgScale() {
      // 检查当前图片比例是否需要放大显示
      if (this.now.type-0 !== 1) return

      const img = this.$refs.img
      const imgWidth = img.getBoundingClientRect().width
      const imgHeight = img.getBoundingClientRect().height
      const scale = imgWidth/imgHeight
      const standard = 0.5

      if (scale < standard) {
        this.$set(this.originImg, 'show', true)
      } else {
        this.resetBiggerImg()
      }

    },
    toggleBiggerImg() {
      this.$set(this.originImg, 'on', !this.originImg.on)
    },
    resetBiggerImg() {
      // 恢复原图切换
      this.$set(this.originImg, 'show', false)
      this.$set(this.originImg, 'on', false)
    },
    upward() {
      // 上一张
      let now = null
      this.list.forEach((i, d) => {
        if (this.now.url === i.url) {
          if (this.list[d-1]) {
            now = this.list[d-1]
          }
        }
      })

      if (now) {
        this.now = now

        this.$set(this.originImg, 'on', false)

        if (now.type-0 != 1) {
          this.$set(this.originImg, 'show', false)
        }
      }
    },
    downward() {
      // 下一张
      let now = null
      this.list.forEach((i, d) => {
        if (this.now.url === i.url) {
          if (this.list[d+1]) {
            now = this.list[d+1]
          }
        }
      })

      if (now) {
        this.now = now

        this.$set(this.originImg, 'on', false)

        if (now.type-0 != 1) {
          this.$set(this.originImg, 'show', false)
        }
      }
    },
    disableContextMenu() {
      // 隐藏右键菜单
      this.$refs.img.oncontextmenu = function(event) {
        return false
      }
      this.$refs.video.oncontextmenu = function(event) {
        return false
      }
      this.$refs.audio.oncontextmenu = function(event) {
        return false
      }

      document.body.style.overflow = 'hidden'
    }
  }
}
</script>

<style lang="less" scoped>
.dialog {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1222;
  width: 100%;
  height: 100%;
  background: rgba(#000000,0.9);
  display: flex;
  justify-content: center;
  align-items: center;

  .container {
    width: 1000px;
    height: 100vh;
    position: relative;
    padding: 0;
    display: flex;
    align-items: center;
    .left {
      width: 35px;
      height: 100%;
      margin-right: 65px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .right {
      width: 50px;
      height: 100%;
      margin-left: 50px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .half {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: center;
    }
    .content {
      position: relative;
      width: 750px;
      height: 422px;
      display: flex;
      justify-content: center;
      align-items: center;

      .close {
        position: absolute;
        top: 20px;
        right: 20px;
        width: 36px;
        height: 36px;
        z-index: 99999;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .close {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      // background: #353535 url("../../assets/img/common/close-white.svg") no-repeat;
      // background-repeat: no-repeat;
      // background-position: center;
      // position: absolute;
      // top: -70px;
      // right: -70px;
      margin-bottom: 20px;
      cursor: pointer;
    }

    .bigger {
      width: 50px;
      height: 50px;
      margin-bottom: 200px;
      img {
        cursor: pointer;
        width: 100%;
        height: 100%;
      }
    }

    .biggerImg {
      height: 100vh !important;
      overflow-y: auto;
      display: block !important;
      img {
        max-height: none !important;
      }
      &::-webkit-scrollbar {
        width: 0;
        height: 0;
      }
    }

    // ._xnsaudio {
    //   width: 600px;
    //   height: 100px;
    //   border-radius: 4px;
    //   box-shadow: 4px 4px 10px rgba(5, 10, 15, 0.05);
    //   background-color: #f9f9f9;
    //   padding: 10px 20px;
    //   display: flex;
    //   audio {
    //     visibility: hidden;
    //   }
    //   ._xnsleft {
    //     width: 80px;
    //     margin-right: 30px;
    //     display: flex;
    //     align-items: center;
    //     justify-content: center;
    //     background-image: url(../../assets/img/common/infoplay.png);
    //     background-repeat: no-repeat;
    //     background-position: left top;
    //     img {
    //       cursor: pointer;
    //     }
    //   }
    //   .playing {
    //     ._xnsplay{
    //       display: none;
    //     }
    //     ._xnspause{
    //       display: block;
    //     }
    //   }
    //   .pausing {
    //     ._xnsplay{
    //       display: block;
    //     }
    //     ._xnspause{
    //       display: none;
    //     }
    //   }
    //   ._xnsright {
    //     flex: 1;
    //     display: flex;
    //     flex-direction: column;
    //     justify-content: space-between;
    //     ._xnstitle {
    //       font-size: 14px;
    //       color: #050f0f;
    //     }
    //     ._xnsinfo {
    //       display: flex;
    //       justify-content: space-between;
    //       align-items: center;
    //       ._xnsauthor {
    //         color: #b9c3c3;
    //         font-size: 12px;
    //       }
    //       ._xnstimer {
    //         color: #b9c3c3;
    //         font-size: 12px;
    //         font-weight: bold;
    //       }
    //     }
    //     ._xnsprogress {
    //       width: 100%;
    //       height: 4px;
    //       border-radius: 2px;
    //       background-color: rgba(0, 0, 0, 0.1);
    //       margin-bottom: 4px;
    //       ._xnspercent {
    //         height: 100%;
    //         width: 0%;
    //         border-radius: 2px;
    //         background-color: #41B48C;
    //         position: relative;
    //         ._xnsbar {
    //           background-color: #fff;
    //           width: 14px;
    //           height: 14px;
    //           margin: -7px -7px 0 0;
    //           border-radius: 100%;
    //           box-shadow: 6px 6px 20px rgba(0, 0, 0, 0.5);
    //           position: absolute;
    //           right: 0;
    //         }
    //       }
    //     }
    //   }
    // }

    .img,
    .video {
      width: 750px;
      height: 422px;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        max-width: 100%;
        max-height: 100%;
        border-radius: 4px;
        display: block;
        margin: 0 auto;
      }
      video, audio {
        max-width: 100%;
        max-height: 100%;
        border-radius: 4px;

        // &::-webkit-media-controls {
        //   overflow: hidden !important
        // }
        // &::-webkit-media-controls-enclosure {
        //   width: calc(100% + 32px);
        //   margin-left: auto;
        // }
      }

    }

    .next,
    .prev {
      width: 35px;
      height: 35px;
      background: url("../../assets/img/common/img-next.svg") no-repeat;
      background-repeat: no-repeat;
      background-position: center;
      cursor: pointer;
    }

    .prev {
      // left: -65px;
      transform: rotate(-180deg);
    }

    .btn {
      width: 100%;
      height: 45px;
      position: absolute;
      bottom: -50px;
      left: 0;
      display: flex;
      justify-content: center;

      button {
        border: 1px solid #787878;
        border-radius: 4px;
        width: 99px;
        height: 39px;
        margin: 0 10px;
        background: none;
        font-size: 14px;
        color: #ffffff;

        &.on {
          background-color: #787878;
          color: #000;
        }

        &.down {
          text-align: left;
          text-indent: 50px;
          background: url("../../assets/img/common/down-white.svg") no-repeat;
          background-position: 20px center;
        }
      }
    }

    .pages {
      position: absolute;
      bottom: 40px;
      left: 0;
      width: 100%;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      .page {
        text-align: center;
        height: 22px;
        width: 80px;
        border-radius: 4px;
        background-color: rgba(0, 0, 0, 0.4);
      }
    }
  }
}
</style>
